// extracted by mini-css-extract-plugin
module.exports = {"message":"style_message__KCejI","reloadButtonArea":"style_reloadButtonArea__bv7bL"};